import { indexOf } from 'lodash'
import { useEffect, useState } from 'react'

export const Trustpilot = ({
  dataTemplateId,
  theme,
  hideCarousel,
}: {
  dataTemplateId: string
  theme: 'light' | 'dark'
  hideCarousel?: boolean
}) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (loaded === true) return

    const aScript = document.createElement('script')
    aScript.type = 'text/javascript'
    aScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    aScript.setAttribute('async', 'true')

    document.head.appendChild(aScript)
    aScript.onload = () => {
      const trustbox = document.querySelectorAll('.trustpilot-widget')
      trustbox.forEach((node) => {
        window.Trustpilot.loadFromElement(node)
      })
      setLoaded(true)
    }
  }, [loaded])

  return (
    <>
      <div
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id={dataTemplateId}
        data-businessunit-id="5f062fb9e287e40001964c3a"
        data-style-height="20px"
        data-style-width="100%"
        data-theme={theme}
      >
        <a
          href="https://www.trustpilot.com/review/wefeedraw.com"
          target="_blank"
          rel="noreferrer"
          style={{ position: 'absolute', left: '-100vw', height: '0px' }}
        >
          Trustpilot
        </a>
      </div>
      {!hideCarousel && (
        <div
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="54ad5defc6454f065c28af8b"
          data-businessunit-id="5f062fb9e287e40001964c3a"
          data-style-height="240px"
          data-style-width="100%"
          data-theme={theme}
          data-stars="4,5"
          data-review-languages="en"
        >
          <a
            href="https://www.trustpilot.com/review/wefeedraw.com"
            target="_blank"
            rel="noreferrer"
            style={{ position: 'absolute', left: '-100vw', height: '0px' }}
          >
            Trustpilot
          </a>
        </div>
      )}
    </>
  )
}
